export const tenantLandlordReferralFields = [
  {
    name: 'lead_name',
    required: true,
    fieldType: 'text',
  },
  {
    name: 'lead_phone_number',
    required: true,
    fieldType: 'number',
  },
  {
    name: 'time_to_contact',
    required: false,
    fieldType: 'text',
  },
] as const;

export enum TenantLandlordReferralWebpageSource {
  QUESTIONNAIRE_VISIT = 'questionnaire_visit',
  VISIT_AGENDA = 'agenda_visits',
  TENANT_DOCUMENT = 'tenant_document',
  VISIT_ON_HOLD = 'visits_on_hold',
}
